import styled from 'styled-components';

const HeroHeading = styled.h1`
  color: currentColor;
  font-family: ${Styles.fontFamily.base};
  font-size: 32.25px;
  letter-spacing: -2px;
  line-height: 90%;
  margin: 0;
  text-align: center;
  width: 100%;

  ${Styles.desktop`
    font-size: 5rem;
    margin-bottom: 2.5rem;
    text-align: left;
  `}

  & small {
    display: inline-block;
    font-size: 3.4375rem;
    left: -5px;
    letter-spacing: -1px;
    position: relative;
    text-decoration: none;
    text-transform: lowercase;
    top: -0.7rem;
    transform: translateY(0.2em);
    vertical-align: top;

    ${Styles.desktop`
      font-size: 6rem;
      position: relative;
      top: -1.2rem;
    `}
  }
`;

export default HeroHeading;
